import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, map, isEmpty } from 'lodash/fp';
import { FlexboxGrid, Col, Tag } from 'rsuite';
import { QueryLabels } from '../constants';

const QueryLabel = styled.span`
  color: #575757;
  font-size: 13px;
  margin-bottom: 10px;
  display: inline-block;
`;

const CustomTag = styled(Tag)`
  font-size: 11px;
  margin-top: 1px;
  margin-left: 1px !important;
`;

function SearchDetails({ searchDetails, reportName }) {
  const [dateFrom, dateTo] = get('dateRange', searchDetails).split(' - ');
  const groupBy = get('groupBy', searchDetails);
  const sumOrCountBy = get('sumOrCountBy', searchDetails);
  const resultBy = get('resultBy', searchDetails);
  const reportAs = get('reportAs', searchDetails);
  const firstTimeBy = get('firstTimeBy', searchDetails);
  const reportType = get('reportType', searchDetails);
  return (
    <FlexboxGrid style={{ marginBottom: 20 }}>
      <Fragment>
        <FlexboxGrid.Item componentClass={Col} sm={4}>
          <QueryLabel>Report Name:</QueryLabel>
        </FlexboxGrid.Item>
        <FlexboxGrid.Item componentClass={Col} sm={20}>
          <CustomTag color={reportName ? 'blue' : 'yellow'}>
            {reportName || 'No Report Name given'}
          </CustomTag>
        </FlexboxGrid.Item>
      </Fragment>
      {searchDetails.dateRange && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>Date Range:</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            <CustomTag color="blue">
              {dateFrom} - {dateTo}
            </CustomTag>
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {searchDetails.locations && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('locations', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            {map(
              item => (
                <CustomTag key={`location_${item}`} color="blue">
                  {item}
                </CustomTag>
              ),
              searchDetails.locations
            )}
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {searchDetails.trackingMethods && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('trackingMethods', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            {map(
              item => (
                <CustomTag key={`trackingMethod_${item}`} color="blue">
                  {item}
                </CustomTag>
              ),
              searchDetails.trackingMethods
            )}
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {reportType && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('reportType', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            <CustomTag color="blue">{reportType}</CustomTag>
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {firstTimeBy && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('firstTimeBy', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            <CustomTag color="blue">{firstTimeBy}</CustomTag>
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {!isEmpty(groupBy) && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('groupBy', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            {map(
              item => (
                <CustomTag key={`groupBy_${item}`} color="blue">
                  {item}
                </CustomTag>
              ),
              get('groupBy', searchDetails)
            )}
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {!isEmpty(sumOrCountBy) && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('sumOrCountBy', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            {map(
              item => (
                <CustomTag key={`sumOrCountBy_${item}`} color="blue">
                  {item}
                </CustomTag>
              ),
              get('sumOrCountBy', searchDetails)
            )}
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {resultBy && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('resultBy', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            <Tag color="blue">{resultBy}</Tag>
          </FlexboxGrid.Item>
        </Fragment>
      )}
      {reportAs && (
        <Fragment>
          <FlexboxGrid.Item componentClass={Col} sm={4}>
            <QueryLabel>{get('reportAs', QueryLabels)}</QueryLabel>
          </FlexboxGrid.Item>
          <FlexboxGrid.Item componentClass={Col} sm={20}>
            <Tag color="blue">{reportAs}</Tag>
          </FlexboxGrid.Item>
        </Fragment>
      )}
    </FlexboxGrid>
  );
}

export const ReadableQueryType = PropTypes.shape({
  dateRange: PropTypes.string,
  locations: PropTypes.arrayOf(PropTypes.string),
  trackingMethods: PropTypes.arrayOf(PropTypes.string),
  reportType: PropTypes.string,
  reportAs: PropTypes.string,
  reportBy: PropTypes.string,
  resultBy: PropTypes.string,
  firstTimeBy: PropTypes.string
});

SearchDetails.propTypes = {
  searchDetails: ReadableQueryType.isRequired,
  reportName: PropTypes.string
};

SearchDetails.defaultProps = {
  reportName: ''
};

export default SearchDetails;
